"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoreLabels = exports.SingleLabel = exports.LabelColor = exports.WrapperLabel = exports.BaseLabel = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "OrbitNetStyles__Wrapper",
  componentId: "sc-1o5x4w4-0"
})(["display:flex;flex-direction:row;justify-content:center;", ""], function (_ref) {
  var type = _ref.type;
  return type === 'multiple' && "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  ";
});

exports.Wrapper = Wrapper;

var BaseLabel = _styledComponents["default"].div.withConfig({
  displayName: "OrbitNetStyles__BaseLabel",
  componentId: "sc-1o5x4w4-1"
})(["padding:0.2rem;font-size:0.9rem;border-radius:0.2rem;color:white;margin-left:0.3rem;width:6rem;text-align:center;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"]);

exports.BaseLabel = BaseLabel;
var WrapperLabel = (0, _styledComponents["default"])(BaseLabel).withConfig({
  displayName: "OrbitNetStyles__WrapperLabel",
  componentId: "sc-1o5x4w4-2"
})(["background:", ";", ""], function (props) {
  return props.id % 2 === 0 ? '#6988CD' : '#FF9145';
}, function (_ref2) {
  var color = _ref2.color;
  return color && "\n    background: ".concat(color, "\n  ");
});
exports.WrapperLabel = WrapperLabel;
var LabelColor = (0, _styledComponents["default"])(BaseLabel).withConfig({
  displayName: "OrbitNetStyles__LabelColor",
  componentId: "sc-1o5x4w4-3"
})(["background:", ";margin:", ";color:", ";width:auto;max-width:12rem;"], function (props) {
  return props.background;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.color;
});
exports.LabelColor = LabelColor;

var SingleLabel = _styledComponents["default"].span.withConfig({
  displayName: "OrbitNetStyles__SingleLabel",
  componentId: "sc-1o5x4w4-4"
})(["text-align:right;width:100%;color:white;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;font-size:1rem;"]);

exports.SingleLabel = SingleLabel;

var MoreLabels = _styledComponents["default"].div.withConfig({
  displayName: "OrbitNetStyles__MoreLabels",
  componentId: "sc-1o5x4w4-5"
})(["color:", ";margin-left:0.2rem;"], function (_ref3) {
  var textColor = _ref3.textColor;
  return textColor || '#355681';
});

exports.MoreLabels = MoreLabels;